import { makeAutoObservable } from 'mobx';
import React from 'react';
import { CampaignStore } from 'src/domains/casino/state/AppCasino/store/campaign-store/Campaign.store';
import { PopupsStackState } from 'src/AppState/PopupsStackState';
import { Common } from 'src/AppState/Common';

export class CampaignTableState {
    private common: Common;
    private loadingCampaignId: string | null = null;

    public constructor(common: Common) {
        makeAutoObservable(this);
        this.common = common;
    }

    public get isLoading(): string | null {
        return this.loadingCampaignId;
    }

    public handleDeleteCampaign = (campaignId: string): void => {
        const popupsStack = PopupsStackState.get(this.common);
        popupsStack.addPopup(`delete_campaign_${campaignId}`, {
            template: 'generic',
            title: 'Delete Campaign',
            message: <p className='m-0'>Are you certain you want to delete this campaign? This action is irreversible.</p>,
            hasOverlay: true,
            cancel_label: 'Cancel',
            delete_label: 'Delete',
            isLoading: false,
            onDelete: async () => {
                const popup = popupsStack.topPopup;

                const setLoadingState = (state: boolean): void => {
                    if (popup !== undefined) {
                        popup.isLoading = state;
                    }
                };

                try {
                    setLoadingState(true);
                    this.loadingCampaignId = campaignId;

                    const campaignStore = CampaignStore.get(this.common);
                    await campaignStore.deleteCampaign(campaignId);
                } catch (error) {
                    console.error('Error deleting campaign:', error);
                } finally {
                    this.loadingCampaignId = null;
                    popupsStack.closePopupOnTop();
                }
            },
            onCancel: () => {
                this.loadingCampaignId = null;
                popupsStack.closePopupOnTop();
            },
        });
    };
}
